import React from 'react';
import WorldMosaicMVP from './WorldMosaicMVP';

export default function App() {
  return <WorldMosaicMVP />;
}